import Plan from './Plan';
import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/plan';
import {EXAMEN} from '../../../../utility/variables';
import {resetStore} from "../../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.plan,
        tipo_plan: EXAMEN,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(Plan);
